import { useState } from 'react';

import { prepareFilter } from 'libs/common';
import { Controller } from 'libs/control';
import { useSort } from 'libs/hooks';
import { UserGrid } from './grid';
import Filter from './filter';

export const User = (props) => {
  const [items, setItems] = useState({});
  const [offset, setOffset] = useState(0);
  const [count, setCount] = useState(0);
  const [sortParams, setSortParams] = useSort('users', [{ field_name: 'pan', direction: 'asc' }]);

  /**
   * prepare params
   * @param {*} data
   * @returns
   */
  const prepareParams = (data) => {
    //console.log('🚀 ~ prepareParams ~ data:', data);
    const intFields = [];
    const boolFields = ['is_active'];
    const addParams = {};
    return prepareFilter(data, addParams, {
      boolFields,
      intFields,
    });
  };

  // grid actions
  const gridActions = {
    addEntries: (data) => setItems({ ...items, ...data }),
    updateEntry: (id, data) => {
      const newItems = { ...items };
      newItems[id] = { ...newItems[id], ...data };
      setItems(newItems);
    },
    clearEntries: () => setItems({}),
    setSortParams: (data) => setSortParams(data),
    setOffset: (val) => setOffset(val),
    setCount: (val) => setCount(val),
  };

  // grid params
  const gridParams = {
    entries: items,
    offset,
    count,
    sortParams,
  };

  return (
    <Controller
      {...props}
      {...gridParams}
      {...gridActions}
      type="users"
      filterName="usersFilter"
      grid={UserGrid}
      gridFilter={Filter}
      getRequestParams={prepareParams}
    />
  );
};
